"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDateToLocaleString = void 0;
exports.readableDateString = readableDateString;
function readableDateString() {
    return new Date()
        .toLocaleString('en-US', { hour12: true })
        .replace(/:\d{2}\b/, '');
}
const formatDateToLocaleString = (date) => {
    return date.toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
    });
};
exports.formatDateToLocaleString = formatDateToLocaleString;
